/**
 * 新考试报表模块的路由
 */
export default {
  path: 'testReportNew',
  name: 'TestReportNew',
  component: () => import('./index.vue'),
  meta: {
    hideMainNav: false
  }
};
